<!--
    描述：用户组预设角色
    日期：2021/04/29
    作者：zwh
-->
<template>
    <div class="h100">
        <w-split v-model="splitValueL">
            <div class="h100" slot="left">
                <roleTreeTable ref="roleTreeTable" @row-click="roleRowClick"></roleTreeTable>
            </div>
            <div class="h100" slot="right">
                <wSplitRight v-model="splitValueR">
                    <div class="h100" slot="left">
                        <el-col :span="11" class="h100" style="border-right:1px solid #eee">
                            <menuTree ref="menuTree"  @row-click="menuRowClick"></menuTree>
                        </el-col>
                        <el-col :span="13" class="h100" style="border-right:1px solid #eee">
                            <btnTree ref="btnTree"></btnTree>
                        </el-col>
                    </div>
                    <div class="h100" slot="right">
                    </div>
                </wSplitRight>
            </div>
        </w-split>
    </div>
</template>
<script>
import wSplit from '@/components/split/split'
import wSplitRight from '@/components/split/split'
import roleTreeTable from './components/role_tree_table'
import menuTree from './components/menu_tree'
import btnTree from './components/btn_tree'
export default {
    name : '',
    components: {
        wSplit,
        wSplitRight,
        roleTreeTable,
        menuTree,
        btnTree,
    },
    data() {
        return {
            splitValueL: 0.3,
            splitValueR: 0.5,

            clickRoleObj : '',  //角色点击对象
            clickMenuObj : '',  //菜单点击对象
        }
    },
    methods: {
        roleRowClick(e){
            if(e != '' && this.clickRoleObj.id == e.id) return

            this.clickRoleObj = e
            this.menuRowClick('')
            let obj = {groupId : '', roleId : ''}
            if(this.clickRoleObj != '') obj.roleId = e.id

            //菜单信息
            this.$refs.menuTree.init(obj)
        },
        menuRowClick(e){
            this.clickMenuObj = e

            let obj = {groupId : '', menuId : '', roleId : ''}
            if(this.clickRoleObj != '') obj.roleId = this.clickRoleObj.id
            if(this.clickMenuObj != '') obj.menuId = e.id

            //查询按钮列表
            this.$refs.btnTree.init(obj)
        },
    }
}
</script>
<style lang="less">

</style>